import { createFileRoute } from "@tanstack/react-router";
import AdminCriterionTopicsDetailPage from "@/pages/admin/criterion-topics/detail";
import { useCriterionTopicsContext } from "@/pages/admin/criterion-topics";

export const Route = createFileRoute("/app/admin/criterion-topics/$criterionTopicId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { criterionTopicId } = Route.useParams();
  const {
    userCanEditAllCriteria,
    userCanViewAllCriteria,
    criterionTopics,
    updateTopicInList,
    deleteTopic,
    deleting,
  } = useCriterionTopicsContext();

  const criterionTopic = criterionTopics.find((t) => t.id === Number(criterionTopicId));

  return (
    <AdminCriterionTopicsDetailPage
      userCanEditAllCriteria={userCanEditAllCriteria}
      userCanViewAllCriteria={userCanViewAllCriteria}
      id={Number(criterionTopicId)}
      criterionTopic={criterionTopic}
      updateTopicInList={updateTopicInList}
      deleteTopic={deleteTopic}
      deleting={deleting}
    />
  );
}
